import React from 'react';
import ReactDOM from 'react-dom';
//import 'bulma/css/bulma.min.css';
import App from './App';
//import reportWebVitals from './reportWebVitals';


ReactDOM.render(
 
    <App />
 ,
  document.getElementById('root')
);


